<template>
  <div class="LmFab">
    <button
      class="LmFab-button"
      :class="classes"
      @click="$emit('click', $event)"
    >
      <lm-icon :icon="icon" class="LmFab-icon text-white" />
    </button>
    <span v-if="label" class="LmFab-label">{{ label }}</span>
  </div>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'

export default {
  name: 'LmFab',
  components: {LmIcon},
  props: {
    icon: {
      type: String,
      default: 'add'
    },
    rotateIcon: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        this.color ? 'bg-' + this.color : 'bg-gray-900',
        {
          'is-disabled': this.disabled,
          'is-mini': this.mini,
          'is-rotated': this.rotateIcon
        }
      ]
    }
  }
}
</script>

<style scoped>
.LmFab {
  position: relative;
}
.LmFab-label {
  position: absolute;
  right: 64px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 135px;
  height: 48px;
  font-size: 14px;
  background-color: theme('colors.gray.900');
  color: white;
}
.LmFab-button {
  width: 56px;
  height: 56px;
  border-radius: 100%;
  opacity: 0.85;
  color: white;
  @apply flex items-center justify-center;
  &:hover {
    opacity: 1;
    @apply ring-2;
  }
  &.is-rotated .LmFab-icon {
    transform: rotate(45deg);
  }
  &.is-disabled {
    background-color: #e1e1e1;
    color: rgba(0, 0, 0, 0.15);
    pointer-events: none;
  }
  &.is-mini {
    width: 48px;
    height: 48px;
  }
}
.LmFab-icon {
  transition: transform 0.3s;
}
</style>
<style>
.js-focus-visible .LmFab-button:focus:not(.focus-visible) {
  outline: none;
  border: none;
}
</style>
